import React from "react";
import TestResultOverview from "./TestResultOverview";
import "./TestResultOverviewAdministration.scss";

const TestResultOverviewAdministration = () => {
    return (
        <div className="TestResultOverviewAdministration">
            <div className="content">
                <TestResultOverview />
            </div>
        </div>
    );
};

export default TestResultOverviewAdministration;
